import { render, staticRenderFns } from "./SkillGroupPerson.vue?vue&type=template&id=0a570ea9&scoped=true&"
import script from "./SkillGroupPerson.vue?vue&type=script&lang=js&"
export * from "./SkillGroupPerson.vue?vue&type=script&lang=js&"
import style0 from "./SkillGroupPerson.vue?vue&type=style&index=0&id=0a570ea9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a570ea9",
  null
  
)

export default component.exports